<template>
  <div id="app">
    <div id="page-wrapper">
      <v-header/>
      <router-view/>
      <v-social/>
      <v-footer/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

// Custom components
import Header from '@/components/Header'
import Social from '@/components/Social'
import Footer from '@/components/Footer'

// AWS Amplify
import { components } from 'aws-amplify-vue'

// Global CSS from template
import './assets/css/font-awesome.min.css'
import './assets/css/main.css'

Vue.component('v-header', Header)
Vue.component('v-social', Social)
Vue.component('v-footer', Footer)

export default {
  name: 'App',
  components: [
    // AWS Amplify components
    ...components
  ]
}
</script>

<!-- Global styles -->
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue